/**
 * El aviso de DNI vencido (KAN-450, fecha sin hora).
 *
 * El vencimiento es un día de calendario, «AAAA-MM-DD», y un DNI vale hasta el
 * final de ese día. «Hoy» es el día en la zona del proyecto: ni el día UTC (que
 * entre las 21 y las 24 h de Argentina ya es el siguiente) ni el del navegador.
 */
import { hoyEnLaZona } from "../../calendarDate";
// La zona del proyecto, emitida por el generador (la misma que la del server).
import { PROJECT_TIME_ZONE } from "../../../config/projectTimeZone";

/** Vencido: el día de vencimiento es anterior a hoy en la zona del proyecto. Sin fecha, no está vencido. */
export function dniVencido(vencimiento: string | null | undefined, ahora: Date = new Date()): boolean {
  return !!vencimiento && vencimiento < hoyEnLaZona(PROJECT_TIME_ZONE, ahora);
}
